import Component from "@tunnel-components/@pages/supervision/camera/created/component";
import * as React from "react";
// import { CameraCreatedContainerStates } from '@tunnel-models/index'
import {
  CameraCreatedActionCreator,
  SystemSettingsActionCreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChange
 * @name onSubmit
 * @name notify
 * @name refresh
 * @name onExportCSVCamera
 * @name selectSection
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @param props
   */
  public constructor(props: any) {
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      cameraAdded: false,
      directionCamera: "",
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      intertube: false,
      ipCamera: "",
      ipCameraBoolean: false,
      stream: "",
      streamBoolean: false,
      proxyCode: "",
      less: false,
      lineaireLocalisationCamera: 0,
      loading: false,
      more: false,
      nameCamera: "",
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      proposedMaxDistance: "",
      required: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onLocaliZation = this.onLocaliZation.bind(this);
    this.onGetTypeValue = this.onGetTypeValue.bind(this);
    this.onGetSectionValue = this.onGetSectionValue.bind(this);
    this.onGetVueValue = this.onGetVueValue.bind(this);
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidMount
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** vérification de la variable */
    }
    this.setState((state: any): any => ({ loading: true }));
    /** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
    const API_URL = "env";

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      infrastructureCamera: window[API_URL].INFRASTRUCTURE,
      projetCamera: window[API_URL].PROJECT,
    }));

    {
      /** action creator */
    }
    this.props
      .SystemSettingsActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }

  /**
   *
   * @method onGetSectionValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetSectionValue = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    if (!Lodash.isEqual(value, "eudes")) {
      this.setState((state: any): any => ({ sectionCamera: value }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ sectionCamera: "" }));
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      // ...this.state,
      cameraAdded: false,
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      ipCameraBoolean: false,
      streamBoolean: false,
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      more: false,
      less: false,
      lessMore: false,
      required: false,
    }));
  };
  /**
   *
   * @method onGetVueValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetVueValue = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ viewCamera: value }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ viewCamera: "" }));
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      // ...this.state,
      cameraAdded: false,
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      ipCameraBoolean: false,
      streamBoolean: false,
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      more: false,
      less: false,
      lessMore: false,
      required: false,
    }));
  };

  /**
   *
   * @method onGetTypeValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetTypeValue = (value: any) => {
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ typeCamera: value }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ typeCamera: "" }));
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      // ...this.state,
      cameraAdded: false,
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      ipCameraBoolean: false,
      streamBoolean: false,
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      more: false,
      less: false,
      lessMore: false,
      required: false,
    }));
  };
  /**
   *
   * @method onChange
   * @description : On recupère la valeur des inputs
   * @param {  any } event
   * @infos "https://reactjs.org"
   */
  public onChange = (event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      // ...this.state,
      cameraAdded: false,
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      ipCameraBoolean: false,
      streamBoolean: false,
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      more: false,
      less: false,
      lessMore: false,
      required: false,
      [event.target.name]: event.target.value,
    });
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraAdded: false,
      errorcamalreadyexist: false,
      errorserver: false,
      errorserversLoad: false,
      ipCameraBoolean: false,
      streamBoolean: false,
      nameCameraBoolean: false,
      nameCameraMaxLenghtBoolean: false,
      nameCameraSynthaxBoolean: false,
      nameSectionBoolean: false,
      nameTypeBoolean: false,
      nameVueBoolean: false,
      more: false,
      less: false,
      lessMore: false,
      required: false,
    }));
  }
  /**
   *
   * @method onLocaliZation
   * @description: la valeur des couvertures
   * @param {  any } event
   * @infos "https://reactjs.org"
   */
  public onLocaliZation = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        ...this.state,
        cameraAdded: false,
        errorcamalreadyexist: false,
        errorserver: false,
        errorserversLoad: false,
        ipCameraBoolean: false,
        streamBoolean: false,
        nameCameraBoolean: false,
        nameCameraMaxLenghtBoolean: false,
        nameCameraSynthaxBoolean: false,
        nameSectionBoolean: false,
        nameTypeBoolean: false,
        nameVueBoolean: false,
        more: false,
        less: false,
        lessMore: false,
        required: false,
        [event.target.name]: Number(event.target.value),
      });
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.viewCamera !== this.state.viewCamera) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        viewCamera: this.state.viewCamera,
      }));

      if (
        !Lodash.isUndefined(this.state.viewCamera) ||
        !Lodash.isEqual(this.state.viewCamera, "")
      ) {
        {
          /** Empêcher la mutation du state */
        }
        if (this.state.viewCamera === "approche") {
          this.onSectionCameraState();
        } else if (this.state.viewCamera === "fuite") {
          this.onSectionCameraState();
        }
      }
    } else if (prevState.sectionCamera !== this.state.sectionCamera) {
      // this.setState({sectionCamera: this.state.sectionCamera});
      if (
        Lodash.isUndefined(this.state.viewCamera) ||
        Lodash.isEqual(this.state.viewCamera, "")
      ) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ nameVueBoolean: true }));
      } else {
        this.onSectionCameraState();
      }
    } else if (prevState.typeCamera !== this.state.typeCamera) {
      this.setState({ typeCamera: this.state.typeCamera });
    } else if (prevState.intertube !== this.state.intertube) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        errorserver: false,
        less: false,
        lessMore: false,
        loading: false,
        more: false,
      }));
    }
  }
  /**
   * @method onSectionCameraState
   * @description : Définir le sens des sections ( sens 1  ou sens 2)
   * @param {  void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onSectionCameraState = (): void => {
    if (this.state.sectionCamera === "4") {
      /**
       * @deprecated
       */
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        directionCamera: "",
        intertube: true,
        loading: false,
      }));
    } else if (this.state.sectionCamera === "1") {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        directionCamera: 1,
        intertube: false,
        loading: false,
      }));
    } else if (
      this.state.sectionCamera === "2" ||
      this.state.sectionCamera === "3"
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        directionCamera: 2,
        intertube: false,
        loading: false,
      }));
    } else if (
      (false && this.state.sectionCamera === "3") ||
      this.state.sectionCamera === ""
    ) {
      {
        /** Empêcher la mutation du state */
      }
      /**
       * @deprecated
       */
      this.setState((state: any): any => ({
        directionCamera: "",
        intertube: false,
        loading: false,
      }));
    }
  };

  /**
   * @method onCreatedAnCamera
   * @param {  any } event
   * @infos "https://reactjs.org"
   */
  public onCreatedAnCamera = () => {
    this.props
    .CameraCreatedActionCreator(this.state)
    .then(() => this.setState({ loading: false }));
  };
  /**
   * @method onSubmit
   * @param {  any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      Lodash.isUndefined(this.state.typeCamera) ||
      Lodash.isEqual(this.state.typeCamera, "") ||
      Lodash.isEqual(this.state.typeCamera, "eudes")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        nameTypeBoolean: true,
        loading: false,
      }));
    }

    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      Lodash.isUndefined(this.state.viewCamera) ||
      Lodash.isEqual(this.state.viewCamera, "") ||
      Lodash.isEqual(this.state.viewCamera, "eudes")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        nameVueBoolean: true,
        loading: false,
      }));
    } else {
      this.setState({});
    }
    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      Lodash.isUndefined(this.state.sectionCamera) ||
      Lodash.isEqual(this.state.sectionCamera, "") ||
      Lodash.isEqual(this.state.sectionCamera, "eudes")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        nameSectionBoolean: true,
        loading: false,
      }));
    }
    {
      /** Vérification de l'existence d'une variable */
    }
    if (Lodash.isEqual(this.state.nameCamera, "")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ nameCameraBoolean: true, loading: false });
    }
    if (Lodash.isEqual(this.state.stream, "")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ streamBoolean: true, loading: false });
    }    
    if (!Utils.validatorString(this.state.nameCamera)) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        nameCameraSynthaxBoolean: true,
        loading: false,
      }));
    }

    if (!Lodash.isEqual(this.state.ipCamera, "")) {
      if (!Utils.validatorIpValue(this.state.ipCamera)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ ipCameraBoolean: true }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ ipCameraBoolean: false }));
      }
    }

    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      !Lodash.isUndefined(this.state.sectionCamera) &&
      !Lodash.isEqual(this.state.sectionCamera, "") &&
      !Lodash.isEqual(this.state.sectionCamera, "eudes") &&
      !Lodash.isEqual(this.state.nameCamera, "") &&
      !Lodash.isUndefined(this.state.viewCamera) &&
      !Lodash.isUndefined(this.state.typeCamera) &&
      !Lodash.isEqual(this.state.typeCamera, "") &&
      !Lodash.isEqual(this.state.typeCamera, "eudes") &&
      !Lodash.isEqual(this.state.viewCamera, "") &&
      !Lodash.isEqual(this.state.viewCamera, "eudes")
    ) {
      {
        /** Validation de la variable */
      }
      if (
        Utils.validatorString(this.state.nameCamera) &&
        this.state.nameCamera.length <= 12
      ) {
        if (!Lodash.isEqual(this.state.ipCamera, "")) {
          if (Utils.validatorIpValue(this.state.ipCamera)) {
            this.onCreatedAnCamera();

            {
              /** Vérification de l'existence d'une variable */
            }

            // if(this.state.intertube !== true ){
            //  if(this.state.sectionCamera === "3" && false){
            //         { /** Empêcher la mutation du state */}
            //         this.setState((state: any):any =>({ loading: true, cameraAdded: false}));
            //        this.props.CameraCreatedActionCreator(this.state)
            //         .then( () => this.setState((state: any):any =>({ loading: false})))
            //    }else{
            //     this.onCreatedAnCamera();
            // }
            // }else{
            //     { /** Empêcher la mutation du state */}
            //     this.setState((state: any):any =>({ loading: true, cameraAdded: false}));
            //    this.props.CameraCreatedActionCreator(this.state)
            //     .then( () => this.setState((state: any):any =>({ loading: false})))
            // }
          } else {
            this.setState((state: any): any => ({ ipCameraBoolean: true }));
          }
        } else {
          this.onCreatedAnCamera();
          {
            /** Vérification de l'existence d'une variable */
          }
          // if(this.state.intertube !== true){
          // if(this.state.sectionCamera === "3"){
          //    { /** Empêcher la mutation du state */}
          //    this.setState((state: any):any =>({ loading: true, cameraAdded: false}));
          //  this.props.CameraCreatedActionCreator(this.state)
          //       .then( () => this.setState((state: any):any =>({ loading: false})))
          // }else{
          //      this.onCreatedAnCamera();
          //    }
          /// }else{
          //    { /** Empêcher la mutation du state */}
          //    this.setState((state: any):any =>({ loading: true, cameraAdded: false}));
          //    this.props.CameraCreatedActionCreator(this.state)
          //    .then( () => this.setState((state: any):any =>({ loading: false})))
          // }
          this.setState((state: any): any => ({ ipCameraBoolean: false }));
        }
      } else if (this.state.nameCamera.length > 12) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          nameCameraMaxLenghtBoolean: true,
          loading: false,
        }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          nameCameraBoolean: true,
          loading: false,
        }));
      }
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }

      if (!Lodash.isUndefined(nextProps.error)) {
        if (nextProps.error.indexOf("409") !== -1) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            errorcamalreadyexist: true,
            data: {},
            cameraAdded: false,
          }));
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            errorserver: true,
            cameraAdded: false,
          }));
        }
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** Empêcher la mutation du state */
      }
      if (!Lodash.isUndefined(nextProps.data)) {
        if (
          Lodash.isUndefined(nextProps.error) &&
          !Lodash.isEmpty(nextProps.data)
        ) {
          this.setState((state: any): any => ({
            errorserver: false,
            cameraAdded: true,
            required: false,
          }));
        }
      }
    } else if (nextProps.errorsettings !== this.props.errorsettings) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.errorsettings)) {
        this.setState((state: any): any => ({ errorserversLoad: true }));
      }
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onLocaliZation={this.onLocaliZation}
        onGetTypeValue={this.onGetTypeValue}
        onGetVueValue={this.onGetVueValue}
        onGetSectionValue={this.onGetSectionValue}
        {...this.state}
        {...this.props}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.CameraCreated.data,
    error: state.CameraCreated.error,
    errorsettings: state.SystemSettings.error,
    sections: state.SystemSettings.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CameraCreatedActionCreator,
  SystemSettingsActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/created/container.tsx